import React, { Component } from "react";
import { Dashboard as DashboardLayout } from "layouts";
import { firestore_db } from "../../config/firebase_config";

import {
  withStyles,
  Paper,
  Typography,
  TextField,
  Button,
  Avatar,
  Checkbox,
  Divider,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
} from "@material-ui/core";

import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const styles = () => ({
  root: {
    padding: 24,
    maxWidth: 1300,
    margin: "0 auto",
  },
  card: { padding: 20, borderRadius: 12 },
  filters: {
    display: "flex",
    gap: 15,
    marginBottom: 20,
    flexWrap: "wrap",
    alignItems: "center",
  },
  tableWrap: {
    marginTop: 20,
    borderRadius: 10,
    border: "1px solid #eee",
    maxHeight: "50vh",
    overflowY: "auto",
    overflowX: "auto",
  },
});

class SendAlerts extends Component {
  state = {
    data: [],
    filteredUsers: [],
    selectedUsers: {},

    country: "",
    state: "",
    city: "",

    countryOptions: [],
    stateOptions: [],
    cityOptions: [],

    emailTitle: "",
    emailContent: "",
    loading: false,

    page: 0,
    rowsPerPage: 10,
  };

  componentDidMount() {
    this.loadUsers();
  }

  getUniqueValues = (arr, key) => [
    ...new Set(arr.map((i) => i[key]).filter(Boolean)),
  ];

  loadUsers = async () => {
    this.setState({ loading: true });

    const snap = await firestore_db.collection("users").get();

    const users = snap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    this.setState({
      data: users,
      filteredUsers: users,
      countryOptions: this.getUniqueValues(users, "country"),
      loading: false,
    });
  };

  handleChange = (key, value) => {
    this.setState((prev) => {
      let update = { [key]: value };

      if (key === "country") {
        update.state = "";
        update.city = "";

        update.stateOptions = this.getUniqueValues(
          prev.data.filter((u) => u.country === value),
          "region",
        );

        update.cityOptions = [];
      }

      if (key === "state") {
        update.city = "";

        update.cityOptions = this.getUniqueValues(
          prev.data.filter(
            (u) => u.country === prev.country && u.region === value,
          ),
          "city",
        );
      }

      return update;
    }, this.filterUsers);
  };

  filterUsers = () => {
    const { data, country, state, city } = this.state;

    const filtered = data.filter(
      (u) =>
        (!country || u.country === country) &&
        (!state || u.region === state) &&
        (!city || u.city === city),
    );

    this.setState({ filteredUsers: filtered, page: 0 });
  };

  // ===== ENTERPRISE SELECT =====

  toggleUser = (id) => {
    this.setState((prev) => ({
      selectedUsers: {
        ...prev.selectedUsers,
        [id]: !prev.selectedUsers[id],
      },
    }));
  };

  toggleSelectAll = () => {
    const { filteredUsers, selectedUsers } = this.state;

    const allSelected = filteredUsers.every((u) => selectedUsers[u.id]);

    let updated = { ...selectedUsers };

    if (allSelected) {
      filteredUsers.forEach((u) => delete updated[u.id]);
    } else {
      filteredUsers.forEach((u) => {
        updated[u.id] = true;
      });
    }

    this.setState({ selectedUsers: updated });
  };

  clearFilters = () => {
    this.setState((prev) => ({
      country: "",
      state: "",
      city: "",
      stateOptions: [],
      cityOptions: [],
      filteredUsers: prev.data,
      page: 0,
    }));
  };

  handleSend = async () => {
    try {
      const selectedUsers = this.state.filteredUsers.filter(
        (u) => this.state.selectedUsers[u.id],
      );

      const res = await fetch(
        "https://us-central1-tv-trivision.cloudfunctions.net/api/sendAlertEmail",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            users: selectedUsers,
            title: this.state.emailTitle,
            html: this.state.emailContent,
          }),
        },
      );

      const result = await res.json();

      alert(result.message);

      // RESET AFTER SEND
      this.setState((prev) => ({
        selectedUsers: {},
        country: "",
        state: "",
        city: "",
        stateOptions: [],
        cityOptions: [],
        filteredUsers: prev.data,
        emailTitle: "",
        emailContent: "",
        page: 0,
      }));
    } catch (err) {
      console.error(err);
      alert("Email sending failed");
    }
  };

  handleChangePage = (_, newPage) => this.setState({ page: newPage });

  handleChangeRowsPerPage = (e) =>
    this.setState({
      rowsPerPage: parseInt(e.target.value, 10),
      page: 0,
    });

  render() {
    const { classes } = this.props;

    const {
      filteredUsers,
      selectedUsers,
      country,
      state,
      city,
      countryOptions,
      stateOptions,
      cityOptions,
      emailTitle,
      emailContent,
      loading,
      page,
      rowsPerPage,
    } = this.state;

    const selectedCount = Object.values(selectedUsers).filter(Boolean).length;

    const allSelected =
      filteredUsers.length > 0 &&
      filteredUsers.every((u) => selectedUsers[u.id]);

    const someSelected =
      filteredUsers.some((u) => selectedUsers[u.id]) && !allSelected;

    const paginatedUsers = filteredUsers.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage,
    );

    return (
      <DashboardLayout title="Send Alerts">
        <div className={classes.root}>
          <Paper className={classes.card} elevation={3}>
            <Typography variant="h5">Send Alerts</Typography>
            <Divider style={{ margin: "20px 0" }} />

            {/* FILTERS */}
            <div className={classes.filters}>
              <FormControl sx={{ minWidth: 180 }}>
                <Select
                  value={country}
                  displayEmpty
                  onChange={(e) => this.handleChange("country", e.target.value)}
                >
                  <MenuItem value="">
                    <em>Select Country</em>
                  </MenuItem>
                  {countryOptions.map((c) => (
                    <MenuItem key={c} value={c}>
                      {c}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl sx={{ minWidth: 180 }}>
                <Select
                  value={state}
                  displayEmpty
                  disabled={!country}
                  onChange={(e) => this.handleChange("state", e.target.value)}
                >
                  <MenuItem value="">
                    <em>Select State</em>
                  </MenuItem>
                  {stateOptions.map((s) => (
                    <MenuItem key={s} value={s}>
                      {s}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl sx={{ minWidth: 180 }}>
                <Select
                  value={city}
                  displayEmpty
                  disabled={!state}
                  onChange={(e) => this.handleChange("city", e.target.value)}
                >
                  <MenuItem value="">
                    <em>Select City</em>
                  </MenuItem>
                  {cityOptions.map((c) => (
                    <MenuItem key={c} value={c}>
                      {c}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Button variant="outlined" onClick={this.clearFilters}>
                Clear Filters
              </Button>
            </div>

            <Typography variant="h6">Users ({filteredUsers.length})</Typography>

            {/* TABLE */}
            <div className={classes.tableWrap}>
              {loading ? (
                <CircularProgress />
              ) : (
                <Table stickyHeader style={{ minWidth: 900 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <b>NAME</b>
                      </TableCell>
                      <TableCell>
                        <b>CITY</b>
                      </TableCell>
                      <TableCell>
                        <b>REGION</b>
                      </TableCell>
                      <TableCell>
                        <b>COUNTRY</b>
                      </TableCell>
                      <TableCell>
                        <b>EMAIL</b>
                      </TableCell>
                      <TableCell>
                        <Checkbox
                          checked={allSelected}
                          indeterminate={someSelected}
                          onChange={this.toggleSelectAll}
                        />
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {paginatedUsers.map((user) => (
                      <TableRow key={user.id} hover>
                        <TableCell>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 10,
                            }}
                          >
                            <Avatar src={user.avatar}>
                              {user.name?.charAt(0)}
                            </Avatar>
                            {user.name}
                          </div>
                        </TableCell>
                        <TableCell>{user.city || "-"}</TableCell>
                        <TableCell>{user.region || "-"}</TableCell>
                        <TableCell>{user.country || "-"}</TableCell>
                        <TableCell>{user.email || "-"}</TableCell>
                        <TableCell>
                          <Checkbox
                            checked={!!selectedUsers[user.id]}
                            onChange={() => this.toggleUser(user.id)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </div>

            <TablePagination
              component="div"
              count={filteredUsers.length}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={this.handleChangePage}
              onRowsPerPageChange={this.handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25, 50]}
            />

            <Divider style={{ margin: "25px 0" }} />

            {/* ===== ENTERPRISE MESSAGE COMPOSER ===== */}
            <Paper className={classes.messageCard} elevation={0}>
              {/* HEADER */}
              <div className={classes.messageHeader}>
                <Typography variant="h6">Alert Message Composer</Typography>

                <Typography variant="body2" color="textSecondary">
                  Selected Users: {selectedCount}
                </Typography>
              </div>

              {/* EMAIL TITLE */}
              <TextField
                fullWidth
                label="Email Subject"
                variant="outlined"
                value={emailTitle}
                placeholder="Enter email subject..."
                onChange={(e) =>
                  this.handleChange("emailTitle", e.target.value)
                }
                style={{ marginBottom: 15 }}
              />

              {/* RICH TEXT EDITOR */}
              <div className={classes.quillWrapper}>
                <ReactQuill
                  theme="snow"
                  value={emailContent}
                  onChange={(v) => this.handleChange("emailContent", v)}
                  style={{ minHeight: 200 }}
                />
              </div>

              {/* FOOTER ACTION AREA */}
              <div className={classes.sendArea}>
                <Typography variant="body2" color="textSecondary">
                  Characters:{" "}
                  {emailContent?.replace(/<[^>]*>/g, "").length || 0}
                </Typography>

                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  disabled={!selectedCount || !emailContent}
                  onClick={this.handleSend}
                  style={{
                    borderRadius: 8,
                    padding: "10px 24px",
                  }}
                >
                  Send Alert ({selectedCount})
                </Button>
              </div>
            </Paper>
          </Paper>
        </div>
      </DashboardLayout>
    );
  }
}

export default withStyles(styles)(SendAlerts);
